import { render, staticRenderFns } from "./CustomMetadataDisplay.vue?vue&type=template&id=eab8bfe2&lang=pug"
import script from "./CustomMetadataDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomMetadataDisplay.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports